class PackagesCompare {
    constructor(section) {
        if (!section) return;
        this.root = section;

        this.init();
    }

    init() {
        this.leftGroups = this.root.querySelectorAll('[data-left-key]');
        this.packagesGroups = this.root.querySelectorAll(
            '[data-left-target-key]'
        );
        this.select = this.root.querySelector('select');
        this.selectOptionText = this.root.querySelector('[js-select-option]');
        this.scrollableElement = this.root.querySelector(
            '[js-scrollable-element]'
        );
        this.scrollbar = this.root.querySelector('[js-scrollbar]');

        this.handleScrollbarWidth();
        this.events();
    }

    events() {
        window.addEventListener('load', this.handleGroupsHeights.bind(this));
        window.addEventListener('resize', this.handleGroupsHeights.bind(this));

        window.addEventListener('resize', this.handleScrollbarWidth.bind(this));
        this.scrollableElement.addEventListener(
            'scroll',
            this.handleScrollbarWidth.bind(this)
        );

        if (this.select) {
            this.select.addEventListener(
                'change',
                this.onSelectChange.bind(this)
            );
        }
    }

    handleScrollbarWidth() {
        const totalPages = Math.round(
            this.scrollableElement.scrollWidth /
                this.scrollableElement.clientWidth
        );

        const scrollProgress =
            (((this.scrollableElement.scrollLeft + 16) /
                this.scrollableElement.clientWidth +
                1) /
                totalPages) *
            100;

        this.scrollbar.style.width = `${scrollProgress}%`;
    }

    onSelectChange(e) {
        const { value } = e.target;
        const textToSet = this.select.querySelector(
            `option[value="${value}"]`
        )?.textContent;

        this.leftGroups.forEach(element => {
            const id = element.getAttribute('data-left-key');
            element.classList.add('max-desktop:hidden');
            if (id == value) {
                element.classList.remove('max-desktop:hidden');
            }
        });

        this.packagesGroups.forEach(element => {
            const id = element.getAttribute('data-left-target-key');
            element.classList.add('max-desktop:hidden');
            if (id == value) {
                element.classList.remove('max-desktop:hidden');
            }
        });
        this.handleGroupsHeights();
        this.selectOptionText.textContent = textToSet;
    }

    handleGroupsHeights() {
        if (this.leftGroups.length && this.packagesGroups.length) {
            this.leftGroups.forEach(leftGroup => {
                const liItems = leftGroup.querySelectorAll('li');
                const heights = Array.from(liItems).map(
                    item => item.offsetHeight
                );

                const id = leftGroup.getAttribute('data-left-key');
                const packagesGroupsToSet = Array.from(
                    this.packagesGroups
                ).filter(
                    item => item.getAttribute('data-left-target-key') === id
                );

                packagesGroupsToSet.forEach(element => {
                    const liItemsInner = element.querySelectorAll('li');

                    liItemsInner.forEach((liItem, key) => {
                        liItem.style.height = `${heights[key]}px`;
                    });
                });
            });
        }
    }
}

const sections = document.querySelectorAll('section.packages-compare');

if (sections.length) {
    sections.forEach(element => {
        new PackagesCompare(element);
    });
}
